import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7aae1fcc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=7aae1fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aae1fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aae1fcc')) {
      api.createRecord('7aae1fcc', component.options)
    } else {
      api.reload('7aae1fcc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=7aae1fcc&scoped=true&", function () {
      api.rerender('7aae1fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kGV9wU57yceE/JS/comp/PopupDialog.vue"
export default component.exports